import type { ReactNode } from 'react';
import type { SuccessScore } from '@mlm/shared';
import { SUCCESS_SCORE_MAX, type SuccessScoreComponent } from '@mlm/shared/coaching';
import { Eyebrow } from '../primitives';
import { SCORE_LABELS } from '../../lib/score';

export function ScoreBreakdown({ score, heading }: { score: SuccessScore; heading?: ReactNode }) {
  return (
    <section>
      {heading && <Eyebrow className="border-b border-border px-5 pb-3 pt-9">{heading}</Eyebrow>}
      {(Object.keys(SCORE_LABELS) as SuccessScoreComponent[]).map((c) => (
        <div
          key={c}
          className="flex items-center justify-between border-b border-border px-5 py-3.5"
        >
          <span className="text-[0.95rem] text-ink">{SCORE_LABELS[c]}</span>
          <span className="font-mono text-sm text-ink">
            {score.breakdown[c]}/{SUCCESS_SCORE_MAX[c]}
          </span>
        </div>
      ))}
    </section>
  );
}
